<template>
  <div class="calendar-day bg-soft">
    <div
      v-if="loading"
      class="p-5 d-flex justify-content-center align-items-center"
    >
      <custom-result-not-found text="Cargando información..." />
    </div>

    <div
      v-else-if="!model.length"
      class="p-5 d-flex justify-content-center align-items-center"
    >
      <custom-result-not-found text="No hay información disponible." />
    </div>

    <div v-else class="calendar-day__list">
      <div
        v-for="(appointment, index) in model"
        :key="appointmentKey(appointment, index)"
        class="calendar-day__item"
        :style="appointmentStyle(appointment)"
        role="button"
        tabindex="0"
        @click="$emit('select-appointment', appointment)"
        @keyup.enter="$emit('select-appointment', appointment)"
      >
        <div class="calendar-day__title">
          <i class="fas fa-folder-open mr-2" />
          <span>{{ appointmentTitle(appointment) }}</span>
          <strong class="calendar-day__student">
            {{ studentFullName(appointment) }}
            <span
              v-if="studentSie(appointment)"
              class="calendar-day__student-sie"
            >
              - {{ studentSie(appointment) }}
            </span>
          </strong>
          <span
            v-if="appointment.compuAppointmentNumber"
            class="calendar-day__appointment-number"
          >
            | {{ appointment.compuAppointmentNumber }}
          </span>
        </div>

        <div class="calendar-day__meta">
          <span class="calendar-day__time">
            <i
              class="fas fa-clock mr-1"
              :style="{ color: getAppointmentColor(appointment) }"
            />
            {{ formatAppointmentTime(appointment.startTime) }} -
            {{ formatAppointmentTime(appointment.endTime) }}
          </span>

          <span
            class="calendar-day__citation"
            :style="citationStyle(appointment)"
          >
            <i class="fas fa-calendar-alt mr-1" />
            {{ citationLabel(appointment) }}
          </span>

          <span class="calendar-day__status">
            <span
              class="calendar-day__status-dot"
              :style="{ backgroundColor: getStatusDotColor(appointment) }"
            />
            {{ appointment.statusName || 'Coordinada' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomResultNotFound from 'custom-result-not-found';
import calendarAppointmentDisplayMixin from '../mixins/calendarAppointmentDisplayMixin';

export default {
  name: 'CompuCalendarModeDay',
  mixins: [calendarAppointmentDisplayMixin],
  props: {
    value: { type: Array, default: () => [] },
    categories: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  components: {
    CustomResultNotFound,
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.calendar-day {
  min-height: 520px;
  padding: 14px;
}

.calendar-day__list {
  display: flex;
  flex-direction: column;
}

.calendar-day__item {
  min-height: 48px;
  border-radius: 3px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  padding: 10px 12px;
  margin-bottom: 10px;
  cursor: pointer;
}

.calendar-day__title {
  display: flex;
  align-items: center;
  min-width: 0;
  font-weight: 600;
  gap: 8px;
}

.calendar-day__title span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-day__student {
  color: #11291b;
  font-size: 12px;
  font-weight: 700;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar-day__student-sie {
  font-weight: 500;
}

.calendar-day__appointment-number {
  color: #11291b;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
}

.calendar-day__meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #11291b;
  font-size: 13px;
  white-space: nowrap;
}

.calendar-day__time {
  color: #11291b;
}

.calendar-day__citation {
  display: inline-flex;
  align-items: center;
  border-radius: 16px;
  color: white;
  font-weight: 600;
  padding: 5px 12px;
}

.calendar-day__status {
  display: inline-flex;
  align-items: center;
  background: white;
  color: #11291b;
  border-radius: 14px;
  padding: 5px 12px;
  font-weight: 600;
}

.calendar-day__status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffd8d2;
  margin-right: 6px;
}

.bg-soft {
  background-color: #f4f6f3;
}

@media (max-width: 992px) {
  .calendar-day__item {
    grid-template-columns: 1fr;
  }

  .calendar-day__meta {
    flex-wrap: wrap;
  }
}
</style>
